"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_serialize_1 = require("@comunica/bus-sparql-serialize");

var rdf_terms_1 = require("rdf-terms");

var stream_1 = require("stream");
/**
 * A comunica Table Sparql Serialize Actor.
 */


var ActorSparqlSerializeTable =
/*#__PURE__*/
function (_bus_sparql_serialize) {
  _inherits(ActorSparqlSerializeTable, _bus_sparql_serialize);

  function ActorSparqlSerializeTable(args) {
    var _this;

    _classCallCheck(this, ActorSparqlSerializeTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlSerializeTable).call(this, args));
    _this.padding = ActorSparqlSerializeTable.repeat(' ', _this.columnWidth);
    return _this;
  }

  _createClass(ActorSparqlSerializeTable, [{
    key: "testHandleChecked",
    value: function () {
      var _testHandleChecked = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(['bindings', 'quads'].indexOf(action.type) < 0)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only handle bindings or quad streams.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testHandleChecked(_x, _x2) {
        return _testHandleChecked.apply(this, arguments);
      }

      return testHandleChecked;
    }()
  }, {
    key: "pad",
    value: function pad(str) {
      if (str.length <= this.columnWidth) {
        return str + this.padding.slice(str.length);
      } else {
        return str.slice(0, this.columnWidth - 1) + '…';
      }
    }
  }, {
    key: "pushHeader",
    value: function pushHeader(data, labels) {
      var header = labels.map(this.pad, this).join(' ');
      data.push(header + '\n' + ActorSparqlSerializeTable.repeat('-', header.length) + '\n');
    }
  }, {
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action, mediaType, context) {
        var _this2 = this;

        var data, resultStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable();

                data._read = function () {
                  return;
                };

                if (action.type === 'bindings') {
                  resultStream = action.bindingsStream;
                  this.pushHeader(data, action.variables);
                  resultStream.on('error', function (e) {
                    return data.emit('error', e);
                  });
                  resultStream.on('data', function (bindings) {
                    return data.push(bindings.map(function (value, key) {
                      return _this2.pad(value ? value.value : '');
                    }).join(' ') + '\n');
                  });
                } else {
                  resultStream = action.quadStream;
                  this.pushHeader(data, rdf_terms_1.QUAD_TERM_NAMES);
                  resultStream.on('error', function (e) {
                    return data.emit('error', e);
                  });
                  resultStream.on('data', function (quad) {
                    return data.push(rdf_terms_1.getTerms(quad).map(function (term) {
                      return _this2.pad(term.value);
                    }).join(' ') + '\n');
                  });
                }

                resultStream.on('end', function () {
                  return data.push(null);
                });
                return _context2.abrupt("return", {
                  data: data
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runHandle(_x3, _x4, _x5) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }], [{
    key: "repeat",
    value: function repeat(str, count) {
      return new Array(count + 1).join(str);
    }
  }]);

  return ActorSparqlSerializeTable;
}(bus_sparql_serialize_1.ActorSparqlSerializeFixedMediaTypes);

exports.ActorSparqlSerializeTable = ActorSparqlSerializeTable;